"use strict";
exports.__esModule = true;
exports.Ticket = void 0;
var Ticket;
(function (Ticket) {
    var Status;
    (function (Status) {
        Status["Booked"] = "booked";
        Status["Cancelled"] = "cancelled";
    })(Status = Ticket.Status || (Ticket.Status = {}));
})(Ticket = exports.Ticket || (exports.Ticket = {}));
